module.exports = __webpack_public_path__ + "static/media/icon-w-guaymas.cf154b14.png";